// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.web-splash-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  z-index: 100002;
  opacity: 1;
  transition: opacity 0.6s ease-out;
}
.web-splash-background.hiding {
  opacity: 0;
}

.splash-position {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 100001;
  overflow: hidden;
  background-color: inherit;
}

.fadeIn {
  animation-name: fadeIn;
  animation-duration: 1000ms;
}

@media screen and (max-width: 700px) {
  .imgSrc {
    transform: scale(1.5);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/core/components/animated-splash/animated-splash.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,iCAAA;AACF;AACE;EACE,UAAA;AACJ;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AACF;;AAEA;EACE,sBAAA;EACA,0BAAA;AACF;;AACA;EACE;IACE,qBAAA;EAEF;AACF","sourcesContent":[".web-splash-background {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: white;\n  z-index: 100002;\n  opacity: 1;\n  transition: opacity 0.6s ease-out;\n\n  &.hiding {\n    opacity: 0;\n  }\n}\n.splash-position {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  z-index: 100001;\n  overflow: hidden;\n  background-color: inherit;\n}\n\n.fadeIn {\n  animation-name: fadeIn;\n  animation-duration: 1000ms;\n}\n@media screen and (max-width: 700px) {\n  .imgSrc {\n    transform: scale(1.5);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
